module.exports = __webpack_public_path__ + "img/2.767341b1.png";